import { Pipe, PipeTransform } from '@angular/core';
import { CustomProductAttributeConfig } from '@ui/products/types';
import {
  ConfigPickerFromPhotographerBoolean,
  ConfigPickerFromPhotographerCounter,
  ConfigPickerFromPhotographerPreConfig,
} from '@ui/products/products-front/components/config-picker-from-photographer-pre-config/types';

@Pipe({
    name: 'skipPickedByPhotographer',
    standalone: false
})
export class SkipPickedByPhotographerPipe implements PipeTransform {
  transform(
    value: Array<CustomProductAttributeConfig & { fixing: boolean }> = [],
    photographerConfig: ConfigPickerFromPhotographerPreConfig
  ): Array<CustomProductAttributeConfig & { fixing: boolean }> {
    if (!photographerConfig) {
      return value;
    }
    return value.filter((config) => {
      switch (config.type) {
        case 'boolean':
          return (
            photographerConfig[
              config.customId
            ] as ConfigPickerFromPhotographerBoolean
          ).clientPick;
          break;
        case 'counter':
          return (
            photographerConfig[
              config.customId
            ] as ConfigPickerFromPhotographerCounter
          ).clientChoice;
          break;
        case 'list':
        case 'size':
          if (photographerConfig[config.customId]) {
            return false;
          }
          return true;
        default:
          return true;
      }
    });
  }
}
